import { SELECTED_DAY_OPTIONS } from '@/const/termSelectOptions'
export default {
  /**
   * 期間条件標準フォーマット
   *
   * 日 / 週 / 月 どれが選択されているか、と開始・終了日を保持します。
   * 期間の種別が週や月であっても、最終的な開始・終了の日付で管理します。
   */
  get() {
    return {
      /**
       * 期間種別（日:d / 週:w / 月:m）
       */
      termType: 'w',
      /**
       * 開始日
       */
      dateFrom: undefined,
      /**
       * 終了日
       */
      dateTo: undefined,
      /**
       * 入力エラー
       */
      errors: [],
      /**
       * ～から、～まで
       */
      weekType: 'COUNT_FROM',
      /**
       * 日付選択か曜日選択か
       */
      selectType: 'date',
      /**
       * 選択した日付のリスト
       * [1, 11, 21]
       */
      selectedDates: [],
      /**
       * 選択した曜日のリスト
       * [0, 1, 2]
       */
      selectedDays: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(term) {
    const selectedDaysSorted = [...SELECTED_DAY_OPTIONS]
      .filter(f => term.selectedDays.includes(f.id))
      .sort((a, b) => a.order - b.order)
      .map(m => m.id)
    return {
      // TODO API側で特に不要なので期間種別は除外していましたが、
      //      分析条件をサーバーから取得して復元する & 期間種別も
      //      復元したい場合、送らざるを得ない。
      termType: term.termType,
      dateFrom: term.dateFrom,
      dateTo: term.dateTo,
      selectType: term.selectType,
      selectedDates: term.selectedDates.sort((a, b) => a - b),
      selectedDays: selectedDaysSorted,
    }
  },
  /**
   * applyToに対してtermを適用する
   * 導入前に保存された条件にはweekTypeがなく、
   * 復元時にはundefinedなのでweekTypeにはデフォルトCOUNT_FROMを入れる
   */
  applyPayload(applyTo, term) {
    applyTo.termType = term.termType
    applyTo.dateFrom = term.dateFrom
    applyTo.dateTo = term.dateTo
    applyTo.weekType = term.weekType || 'COUNT_FROM'
    applyTo.selectType = term.selectType || 'date'
    applyTo.selectedDates = term.selectedDates || []
    applyTo.selectedDays = term.selectedDays || []
  },
}
